import React from 'react'

const ThumbsDownIcon = ({ color = '#000', className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 15.316 15.311">
      <g data-name="thumb-up-svgrepo-com (1)">
        <path
          data-name="Path 922"
          d="M8.3 10.5H5.487a.987.987 0 0 0-.987.987v4.933a.987.987 0 0 0 .987.987H8.3a.148.148 0 0 0 .148-.148v-6.61A.148.148 0 0 0 8.3 10.5z"
          transform="translate(-3.75 -8.764)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        />
        <path
          data-name="Path 923"
          d="m8.5 4.5 1.869 3.738a.986.986 0 0 1 .1.441v1.74a.987.987 0 0 0 .987.987h0a1.973 1.973 0 0 0 1.973-1.973V5.487"
          transform="translate(-3.804 3.155)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        />
        <path
          data-name="Path 924"
          d="M11.46 18.392h5.916a.986.986 0 0 0 .947-1.262L16.6 11.211a.986.986 0 0 0-.947-.711h-3.785a.987.987 0 0 0-.7.289l-.409.409a.987.987 0 0 1-.7.289H8.5"
          transform="translate(-3.804 -9.75)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        />
      </g>
    </svg>
  )
}

export default ThumbsDownIcon
